import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../redux/store';
import { selectDocumentSearchStatus } from '../../redux/selectors/documentSearchSelectors';
import { DBMessageThunks } from '../../redux/thunks/DBServiceThunks';
import DocumentSearchHeader from './DocumentSearchHeader';
import DocumentSearchProgress from './DocumentSearchProgress';
import DocumentSearchResults from './DocumentSearchResults';
import DocumentSearchError from './DocumentSearchError';

const DocumentSearchView: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const currentChatId = useAppSelector(state => state.ChatReducer.currentChatId);
  const status = useAppSelector(selectDocumentSearchStatus);

  useEffect(() => {
    if (currentChatId) {
      dispatch(DBMessageThunks.find({ chatId: currentChatId, $paginate: false }));
    }
  }, [currentChatId, dispatch]);

  return (
    <div className="flex flex-col h-full px-6 py-4 overflow-auto bg-background">
      <DocumentSearchHeader />

      <div className="flex-1 mt-4">
        {status === 'active' && <DocumentSearchProgress />}
        {status === 'completed' && <DocumentSearchResults />}
        {status === 'error' && <DocumentSearchError />}
        {status === 'none' && (
          <p className="text-center text-muted-foreground mt-8 text-sm">
            {t('components.documentSearch.initializing', 'Initializing document search...')}
          </p>
        )}
      </div>
    </div>
  );
};

export default DocumentSearchView;
